import styles from './ImageSlidesMobile.module.scss';

import cx from 'classnames';
import React, { FC } from 'react';
import Slider from 'react-slick';

import type { ContentImageEntry } from 'api/contentful/contentTypes.cloverdotcom';
import { ContentImage } from 'components/ContentImage/ContentImage';

interface IImageSlidesMobileProps {
  images?: ContentImageEntry[];
  variant?: 'product' | 'images-only';
}

const config = {
  className: 'product-mobile-slider',
  dots: true,
  dotsClass: styles.productSlides,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
};

export const ImageSlidesMobile: FC<IImageSlidesMobileProps> = ({ images, variant = 'product' }) => {
  if (!images) return null;

  return (
    <div className={cx(styles.slides, styles[variant])}>
      <Slider {...config}>
        {images.map(image => (
          <div className={cx(styles.slickSlider, styles[variant])} key={image.id}>
            <ContentImage entry={image} className={cx(styles.sliderImage, styles[variant])} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

ImageSlidesMobile.displayName = 'ImageSlidesMobile';
